import {
  ActionBody,
  ActionBody2,
  Body,
  Columnz,
  DataTablez,
  RenderHeader,
  StatusBody,
  TimeBody,
  useGetParams,
} from "@/components/DataTable";
import {
  DropdownForm,
  FormUpdateDialog,
  InputForm,
} from "@/components/FormUpdate";
import { document_status, document_type } from "@/constants";
import { Button, Dialog } from "@/uiCore";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useCountDocument, useListCategory, useListDocument } from "../util";
import { UploadFile } from "@/components/UploadFile";
import { addDocument } from "../api";
import { useListUser } from "@/modules/users/user/util";

const Document = () => {
  const initParams = useGetParams();
  const [paramsPaginator, setParamsPaginator] = useState(initParams);
  const [visible, setVisible] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const [infos, setInfos] = useState({ user_id_manager: userInfo?.user_id });
  const list_category = useListCategory({
    cb_status: undefined,
    first: undefined,
  });
  console.log(list_category);

  const list_document = useListDocument({
    cb_status: undefined,
    first: undefined,
  });
  const count_document = useCountDocument({
    cb_status: undefined,
    first: undefined,
  });
  const userz = useListUser();
  console.log(list_document);

  const handleData = () => {
    let info = { ...infos };

    if (!info.type) return "Vui lòng chọn phân loại";
    if (!info.name) return "Vui lòng nhập tên tài liệu";
    if (!info.category_id) return "Vui lòng chọn dự án";
    if (!info.status) return "Vui lòng chọn trạng thái";

    if (file) {
      // // if (!info.files) info.files = {}; // Khởi tạo `files` nếu chưa tồn tại
      // if (!info.files) info.files = []; // Khởi tạo `documents` nếu chưa tồn tại

      // info.files.files = [
      //   {
      //     name: file.name,
      //     size: file.size,
      //     type: file.type,
      //     preview: file.preview, // Giữ đường dẫn xem trước nếu cần
      //     lastModified: file.lastModified,
      //   },
      // ];
      console.log(file);

      info.file = file;
    }

    return info;
  };
  console.log(userz);
  console.log(userInfo);

  return (
    <div>
      <FormUpdateDialog
        // checkId={true}
        handleData={handleData}
        title="Thêm mới tài liệu dự án"
        visible={visibleAdd}
        setVisible={setVisibleAdd}
        actions={{ add: addDocument }}
        onHide={() => setVisibleAdd(false)}
        handleAfterCallApi={() => window.location.reload()}
      >
        <div className="grid grid-form">
          <div className="col-12 ">
            <div className="grid grid-form">
              <div className="col-12 ">
                <DropdownForm
                  value={infos.type}
                  options={document_type}
                  onChange={(e) => setInfos({ ...infos, type: e.target.value })}
                  label="Phân loại"
                />
                <InputForm
                  id="name"
                  value={infos.name}
                  onChange={(e) => setInfos({ ...infos, name: e.target.value })}
                  label="Tên tài liệu (*)"
                  required
                />
                <DropdownForm
                  value={infos.category_id}
                  options={list_category}
                  optionId="cb_id"
                  optionLabel="cb_title"
                  onChange={(e) =>
                    setInfos({ ...infos, category_id: e.target.value })
                  }
                  label="Dự án (*)"
                />
                <DropdownForm
                  value={infos.status}
                  options={document_status}
                  onChange={(e) =>
                    setInfos({ ...infos, status: e.target.value })
                  }
                  label="Trạng thái (*)"
                />
                <InputForm
                  value={userInfo?.full_name}
                  label="Người cập nhật (*)"
                  disabled
                />
                <UploadFile
                  file={file}
                  setFile={setFile}
                  target="_blank"
                  label="File"
                />
              </div>
            </div>
          </div>
        </div>
      </FormUpdateDialog>
      <DataTablez
        value={list_document}
        header={RenderHeader({
          title: "Danh sách tài liệu",
          setVisibleAdd,
          addDialog: true,
        })}
        title="dự án"
        totalRecords={count_document}
        paramsPaginator={paramsPaginator}
        setParamsPaginator={setParamsPaginator}
      >
        <Columnz
          header="Phân loại"
          body={(e) => document_type?.find((i) => i.id == e?.type)?.name}
        />
        <Columnz field="name" header="Tên tài liệu" />
        <Columnz
          header="Trạng thái"
          body={(e) => document_status?.find((i) => i.id == e?.status)?.name}
        />
        <Columnz header="Người cập nhật" field="user_name" />
        <Columnz
          body={(e) => TimeBody(e.updated_at)}
          header="Thời gian cập nhật"
          bodyStyle={{ textAlign: "center" }}
        />
        <Columnz
          header="Tải xuống"
          body={(e) => {
            let fileUrl = "";
            try {
              fileUrl = e.file ? (typeof e.file === "string" && (e.file.trim().startsWith("{") || e.file.trim().startsWith("[")) ? JSON.parse(e.file) : e.file) : "";
            } catch (err) {
              fileUrl = e.file || "";
            }
            return (
              <a
                href={fileUrl}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="p-button p-component p-button-sm">
                  Download
                </button>
              </a>
            );
          }}
          bodyStyle={{ textAlign: "center" }}
        />

        <Columnz
          header="Hành động"
          body={(e) =>
            ActionBody2({
              rowData: e,
              download: true,
              actions: {
                route: "/project/delete",
                options: () => {
                  setVisible(true);
                  // setCategoryDelete(e.id);
                },
              },
            })
          }
          bodyStyle={{ textAlign: "center", minWidth: "8rem" }}
        />
      </DataTablez>
    </div>
  );
};
export default Document;
